import { render, staticRenderFns } from "./vehicle_workinfo.vue?vue&type=template&id=64c3fc3a&scoped=true"
import script from "./vehicle_workinfo.vue?vue&type=script&lang=js"
export * from "./vehicle_workinfo.vue?vue&type=script&lang=js"
import style0 from "./vehicle_workinfo.vue?vue&type=style&index=0&id=64c3fc3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_77a37368fa9f7d737cecfb85aa182826/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c3fc3a",
  null
  
)

export default component.exports